/***
 *
 *   CATEGORY FORM TAB (stub)
 *   No reference counterpart yet — token-pass empty state until the intake
 *   builder is built. Routes stay under /app/tickets/category/:id/form.
 *
 **********/

import React from 'react';
import { EmptyState } from 'components/lib';
import { useTranslate } from 'app/translations';

const TicketsCategoryForm = () => {
    const { _t } = useTranslate();

    return (
        <EmptyState
            title={_t('ticket.category.form')}
            text={_t('ticket.category.comingSoon')}
            icon="file-text"
        />
    );
};

export default TicketsCategoryForm;
